import axios from "axios";
import { getAuth } from "firebase/auth";
import {
  clienthubBaseURL,
  momentsBaseURL,
  nexusBaseURL,
  zzeehBaseURL,
} from "./constants";

// Function to get the current user's Firebase ID token
const getFirebaseToken = async () => {
  const auth = getAuth();
  const currentUser = auth.currentUser;
  if (currentUser) {
    return await currentUser.getIdToken();
  }
  return null;
};

// Axios request interceptor to attach Authorization header
const attachAuthToken = async (config: any) => {
  const token = await getFirebaseToken();

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`; // Attach token
  }
  return config;
};

const zzeehApiClient = axios.create({
  baseURL: zzeehBaseURL,
});

const momentsApiClient = axios.create({
  baseURL: momentsBaseURL,
});

const clienthubApiClient = axios.create({
  baseURL: clienthubBaseURL,
});

const nexusApiClient = axios.create({
  baseURL: nexusBaseURL,
});

// Attach the request interceptor to both clients
zzeehApiClient.interceptors.request.use(attachAuthToken, (error) => {
  return Promise.reject(error);
});

momentsApiClient.interceptors.request.use(attachAuthToken, (error) => {
  return Promise.reject(error);
});

clienthubApiClient.interceptors.request.use(attachAuthToken, (error) => {
  return Promise.reject(error);
});

nexusApiClient.interceptors.request.use(attachAuthToken, (error) => {
  return Promise.reject(error);
});

export { zzeehApiClient, momentsApiClient, clienthubApiClient, nexusApiClient };
